<template>
    <nav id="NavList">
        <!-- Main Links -->
        <router-link to="/" >Dashboard</router-link>
        <router-link to="/customers">Customers</router-link>
        <router-link to="/projects">Projects</router-link>
        <router-link to="/lockercombinations">Locker Banks</router-link>
        <router-link to="/quotes">Quotes</router-link>        
        <router-link to="/myaccount" >My Account</router-link>
        <router-link to="/lockermodules">Modules</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/inventory">Products</router-link>
        <router-link to="/users">Salespeople</router-link>
        <router-link to="/revenue">Revenue</router-link>
        <router-link to="/mediapack">Media Pack</router-link>
        <router-link to="/supportinvoicer">Support Invoicer</router-link>
        <div v-if="$store.User">
            <router-link v-if="$store.User.admin" to="/renttoown">Rent-To-Own Pricing</router-link>
            <router-link v-if="$store.User.admin" to="/syssettings">System Settings</router-link>
        </div>

        <!-- Account Section -->
        <div id="AccountInfo" >
            <router-link v-if="(User)" to="MyAccount">Welcome back {{User.fname}}</router-link>
            <router-link v-if="(!User)" to="MyAccount">Login</router-link>
        </div>
    </nav>
</template>

<script>
    import { store } from '../store'
    export default {
        name: 'MainMenu',
        data: function () {
            return {timer: '', User: store.User};
        },
        watch: {
            "$store.User":"rerender"
        },
        methods: {
            rerender : function() { this.$forceUpdate() },
            checkLoginChanges: function () { this.User = store.User }
        },
        created () {
            this.User = store.User
            this.timer = setInterval(this.checkLoginChanges, 500) // 500ms
        },
        beforeDestroy () {
           clearInterval(this.timer)
        }
    }
</script>

<style scoped>
    /* LINK STYLES */
    #NavList {
        grid-area: menu;
        justify-self: stretch;
        overflow-y: auto;
        background:#cc3a00;
    }
    #NavList a {
        text-align: center;
        font-size: 2rem;
        display: block;
        text-transform: capitalize;
        color: white;
        padding: 0.5rem 0;
        transition: 0.5s;
    }
    #NavList a:hover,
    #Navlist a:focus,
    #NavList a.router-link-exact-active {
        background: rgba(200,200,200,0.4);
    }

    /* ACCOUNT INFO */
    #AccountInfo {
        width: 100%;
        padding: 3rem 0;
        position: relative;
        bottom: 0;
        background: #333;
        color: #FFF;
    }
    #AccountInfo a {
        color: #FFF;
        transition: 1s;
    }
</style>